import { call, put } from 'redux-saga/effects';
import {
    getAllDevices,
    getDevicePingData,
    getDashboardData,
    deviceOnboardingRequest,
    updateDeviceData,
    deleteDevice,
    toggleDeviceMonitoringStatus
} from '../components/supply-chain/supplyChainService';
import {
    getDevicesDataSuccess,
    getDevicesDataError,
    getDevicesPingStatusSuccess,
    getDevicesPingStatusError,
    getDevicesDashboardDataSuccess,
    getDevicesDashboardDataError,
    deviceOnboardingSuccess,
    deviceOnboardingFailure,
    updateDevicesDataSuccess,
    updateDevicesDataError,
    deleteDevicesDataSuccess,
    deleteDevicesDataError,
    toggleDevicesMonitoringStatusSuccess,
    toggleDevicesMonitoringStatusError
} from '../components/supply-chain/redux/actions';

const normalizeError = (error) => {
    if (error?.response?.data) {
        const data = error.response.data;
        return data.message || data.error || JSON.stringify(data);
    }
    if (error?.message) return error.message;
    if (typeof error === 'string') return error;
    return 'An unexpected error occurred';
};

export function* loadDevicesData({ storeCodes }) {
    try {
        const data = yield call(getAllDevices, { storeCodes });
        yield put(getDevicesDataSuccess(data));
    } catch (error) {
        yield put(getDevicesDataError(normalizeError(error)));
    }
}

export function* loadDevicesPingStatus({ storeCodes }) {
    try {
        const data = yield call(getDevicePingData, { storeCodes });
        yield put(getDevicesPingStatusSuccess(data));
    } catch (error) {
        yield put(getDevicesPingStatusError(normalizeError(error)));
    }
}

export function* loadDevicesDashboardData({ params }) {
    try {
        const data = yield call(getDashboardData, params);
        yield put(getDevicesDashboardDataSuccess(data));
    } catch (error) {
        yield put(getDevicesDashboardDataError(normalizeError(error)));
    }
}

export function* onboardDevice({ payload }) {
    try {
        const response = yield call(deviceOnboardingRequest, payload);
        yield put(deviceOnboardingSuccess(response));
    } catch (error) {
        yield put(deviceOnboardingFailure(normalizeError(error)));
    }
}

export function* updateDevicesData({ payload }) {
    try {
        const response = yield call(updateDeviceData, payload);
        yield put(updateDevicesDataSuccess(response));
    } catch (error) {
        yield put(updateDevicesDataError(normalizeError(error)));
    }
}

export function* deleteDevicesData({ deviceId }) {
    try {
        yield call(deleteDevice, deviceId);
        yield put(deleteDevicesDataSuccess());
    } catch (error) {
        yield put(deleteDevicesDataError(normalizeError(error)));
    }
}

export function* toggleDevicesMonitoringStatus({ deviceId }) {
    try {
        yield call(toggleDeviceMonitoringStatus, deviceId);
        yield put(toggleDevicesMonitoringStatusSuccess());
    } catch (error) {
        yield put(toggleDevicesMonitoringStatusError(normalizeError(error)));
    }
}